import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";

const Box = ({ label, value, testid }) => (
  <div className="bg-secondary rounded-md p-4 text-center"><p className="text-xs text-muted-foreground">{label}</p><p className="font-heading font-extrabold text-xl text-primary" data-testid={testid}>{value}</p></div>
);

function PinReset({ cred, setCred }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [logs, setLogs] = useState([]);
  const loadLogs = async () => { try { setLogs(await api.get(`/students/${cred.id}/pin-resets`)); } catch { setLogs([]); } };
  useEffect(() => { loadLogs(); }, [cred.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const reset = async () => {
    if (!reason.trim()) { toast.error("Indiquez un motif."); return; }
    if (!window.confirm(`Générer un nouveau PIN pour ${cred.name} ? L'ancien PIN ne fonctionnera plus.`)) return;
    try {
      const r = await api.post(`/students/${cred.id}/reset-pin`, { reason });
      setCred({ ...cred, ...r }); setReason(""); setOpen(false); toast.success("PIN réinitialisé"); loadLogs();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <div className="border-t border-border pt-3 space-y-2">
      {!open ? (
        <Button variant="outline" size="sm" onClick={() => setOpen(true)} data-testid="pin-reset-open"><RotateCcw className="h-4 w-4 mr-1" />Réinitialiser le PIN</Button>
      ) : (
        <div className="space-y-2">
          <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motif de la réinitialisation (obligatoire)" data-testid="pin-reset-reason" />
          <div className="flex gap-2">
            <Button size="sm" variant="destructive" onClick={reset} data-testid="pin-reset-confirm">Confirmer la réinitialisation</Button>
            <Button size="sm" variant="ghost" onClick={() => setOpen(false)} data-testid="pin-reset-cancel">Annuler</Button>
          </div>
        </div>
      )}
      {logs.length > 0 && (
        <div className="text-xs" data-testid="pin-reset-log">
          <p className="font-semibold mb-1">Historique des réinitialisations</p>
          <ul className="space-y-1 max-h-32 overflow-y-auto">
            {logs.map((l) => <li key={l.id} className="text-muted-foreground">{new Date(l.at).toLocaleString("fr-FR")} — {l.by_name} — {l.reason}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}

export function StudentLoginModalBody({ cred, setCred, isMaster }) {
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">Identifiants de connexion de {cred.name} (examens sur tablette).</p>
      <div className="grid grid-cols-2 gap-3">
        <Box label="Code de connexion" value={cred.student_code} testid="cred-code" />
        <Box label="PIN" value={cred.pin} testid="cred-pin" />
      </div>
      {cred.created && <p className="text-xs text-emerald-700" data-testid="cred-created-note">Identifiants créés. Ils resteront les mêmes à chaque ouverture.</p>}
      {isMaster && <PinReset cred={cred} setCred={setCred} />}
    </div>
  );
}
